import { Checkbox } from "@mui/material";
import { memo } from "react";

interface SelectAllCheckboxProps {
  allSelected: boolean;
  isIndeterminate: boolean;
  onChange: (checked: boolean) => void;
  style?: React.CSSProperties;
}
export const SelectAllCheckbox = memo(({ allSelected, isIndeterminate, onChange, style }: SelectAllCheckboxProps) => {
  return <Checkbox style={style} checked={allSelected} indeterminate={isIndeterminate} onClick={(e) => onChange(!allSelected)} />;
});
